// extracted by mini-css-extract-plugin
export var createdDate = "_jf-1";
export var divider = "_jf-2";
export var headerDivider = "_jf-3";
export var messagesCard = "_jf-0";
export var messagesContainer = "_jf-6";
export var messagesContainerWrapper = "_jf-4";
export var showLeftPanelButton = "_jf-8";
export var topButtons = "_jf-7";
export var withPadding = "_jf-5";